module.exports = __webpack_public_path__ + "img/grg_negro.d8dc6e4b.svg";